import React, { Fragment, useState, useEffect, useContext } from "react";
import FcardContact from "../../components/FcardContact/FcardContact";
import FcardGroup from "../../components/FcardGroup/FcardGroup";
import FcardPageTitle from "../../components/FcardPageTitle/FcardPageTitle";
import { useNavigate, useLocation } from "react-router";
import FBannerSpendResponsive from "../../components/FBannerSpendResponsive/FBannerSpend";
import FcardPaymentMethod from "../../components/FcardPaymentMethod/FcardPaymentMethod";
import FInput from "../../components/FInput/FInput";
import { useProcessor } from "../../hooks/useProcessor";
import { v4 as uuidv4 } from "uuid";
import { useCurrencyFormat } from "../../hooks/useCurrencyFormat";
import { AuthContext } from "../../context/AuthContext";
import VectorIcons from "../../components/VectorIcons/VectorIcons";
import copy from "copy-to-clipboard";
import FContainer from "../../components/FContainer/FContainer";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import Swal from "sweetalert2";

const ZellePaymentScreen = ({ param }) => {
  const { state } = useLocation();

  const { processPayment } = useProcessor();

  const [ref, setRef] = useState("");

  const { setAlert } = useContext(AuthContext);

  useEffect(() => {
    if (state == null) {
      route("/");
    } else {
      const nextScreen = async () => {
        const data = {
          originCurrencyId: state.originCurrency,
          destinationCurrencyId: state.destinationCurrencyId,
          products: [
            {
              id: state.idFiadoFlash,
              amount: state.transferredAmount,
            },
            {
              id: state.productId,
            },
          ],
        };

        let response = await processPayment(data, uuidv4());
        //console.log(response);
        if (response?.data?.code == "PROCESS_OK") {
          setRef(response.data.data.reference);
        } else {

          Swal.fire({
            showCloseButton: true,
            title: 'Advertencia',
            text: "Ha habido un error al procesar tu transacción, intenta de nuevo por favor.",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            iconColor: "#fd6e0d",
            confirmButtonText: 'Entendido'
          })
        }
      };

      nextScreen();
    }
  }, []);

  const { formatWithCurrencyISO } = useCurrencyFormat();

  const route = useNavigate();

  return (
    <>
      {state != null ? (
        <>
          <FContainer>
            <div className="border-0 grid grid-cols-1 gap-4">
              <div className="col-span-1 grid place-items-center">
                <img
                  src={require("../../components/assets/images/zelle-logo.png")}
                  className="w-[150px], h-[70px]"
                />
              </div>
              <div className="col-span-1 grid place-items-center font-bold text-[30px]">
                {`${formatWithCurrencyISO(
                  state.transferredAmount,
                  state.originCurrency
                )}`}
              </div>
              <div className="col-span-1 grid place-items-center font-medium text-[20px] text-center">
                Paga con Zelle usando el correo electrónico
              </div>
              <div className="col-span-1 grid place-items-center font-bold text-[25px]">
              fiado@fiado.mx
              </div>
              <div className="col-span-1 grid place-items-center font-bold text-[25px] text-[red]">
                Atención
              </div>
              <div className="col-span-1 grid place-items-center  font-medium text-[20px] text-center">
                Debes ingresar en Zelle el siguiente número de Referencia
              </div>
              <div className="col-span-1 grid place-items-center">
                <div className="font-bold text-[25px]">Referencia (para mensaje):</div>
                <div>
                  <div className="float-left text-[20px] font-medium">
                    {ref}
                  </div>
                  <div className="float-left pl-1">
                    <VectorIcons
                      name="md-clipboard-outline"
                      className="cursor-pointer"
                      onClick={() => {
                        copy(ref);
                        alert("Copiado al cortapapeles ");
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-span-1 grid place-items-center font-medium text-[20px] text-center cursor-pointer">
                Cuando completes el envio de Zelle ve al boton <p className="text-Secondary font-bold" onClick={() => route("/LoansScreen")}>"Paga tu Fiado"</p> 
                <p className="float-left">ahi ingresa el # de confirmacion de Zelle</p>
              </div>
              <div className="col-span-1 grid place-items-center">
                <Fbutton
                  value={"Finalizar"}
                  disabled={false}
                  onClick={() => route("/LoansScreen")}
                />
              </div>
            </div>
          </FContainer>
        </>
      ) : (
        route("/")
      )}
    </>
  );
};

export default ZellePaymentScreen;
